<template>
		<joy-page :joyPageStatus="joyPageStatus">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<template v-if="list.length==0">
					<noneData></noneData>
				</template>
				<template v-else>
				<van-list v-model="loading" :finished="finished" finished-text="加载完毕" @load="onLoad">
					<div  class="marginBottomXm" v-for="(item, index) in list"  :key="index">
						<van-cell :title="item.title" @click="go('/pages/detail/detail?id='+item.party_id)"/>
					</div>
				</van-list>
				</template>
			</van-pull-refresh>
		</joy-page>
</template>

<script>
	export default {
		components: {
		},
		created(e) {
			this.onLoad();
		},
		data() {
			return {
				joyPageStatus: '',
				list:'',
				loading: false,
				finished: false,
				isLoading: false,
			};
		},
		methods: {
			go(name){
				this.$router.push(`${name}`);
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					this.reload();
					this.$toast('刷新成功');
				}, 500);
			},
			onLoad() {
				// 异步更新数据
				setTimeout(() => {
					this.loadData();
				}, 500);
			},
			reload() {
				this.list = [];
				this.loading = false;
				this.finished = false;
				this.onLoad();
			},
			loadData(){
				console.log('进来了loadData')
				let id = this.$route.query.id;
				const that=this;
				this.joyPageStatus = 'loading';
				try{
					this.$axios.get('favor/list').then(res => {
						if (res.data.code == 200) {
							this.joyPageStatus = 'success';
							this.list=res.data.data;
							this.loading = false;
							this.finished = true;
							
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		}
	};
</script>

<style>
</style>
